/**
 * useSidebarProjects — bridge between the conversation sidebar and the
 * `features/projects` slice.
 *
 * Thin re-export so the sidebar doesn't reach across the feature boundary
 * directly. If/when the contract changes (e.g. server-side filtering,
 * pinned-first ordering), only this file moves.
 */

import { useProjects } from "@/features/projects";
import type { Project } from "@ando/core/api";

export interface SidebarProjectsResult {
  projects: readonly Project[];
  isLoading: boolean;
}

export function useSidebarProjects(): SidebarProjectsResult {
  const query = useProjects();
  return {
    projects: query.data ?? [],
    isLoading: query.isLoading,
  };
}
